import { createContext, FC, ReactNode, useEffect, useState } from 'react';

import Container, { ContainerProps } from '../Container';
import { Menu } from '../Menu';
import { TestMetadata } from '../types';

export interface ExpandableMenuProps {
  /** Expecting these to be ExpandableMenuSection */
  children?: ReactNode;
  /** Custom class name */
  className?: string;
  /** Should the menu be expanded or not */
  isExpanded?: boolean;
  /** Test ids for menu */
  testMetadata?: TestMetadata;
  /** Container props - no children */
  containerProps?: Omit<ContainerProps, 'children'>;
}

interface ExpandableMenuContextProps {
  /** Is Menu in expanded state or not */
  isExpanded: boolean;
}

export const ExpandableMenuContext = createContext<ExpandableMenuContextProps>({
  isExpanded: true,
});

const ExpandableMenu: FC<ExpandableMenuProps> = ({
  children,
  className,
  isExpanded = true,
  testMetadata,
  containerProps,
  ...otherProps
}) => {
  const [expanded, setExpanded] = useState<boolean>(isExpanded);

  useEffect(() => setExpanded(isExpanded), [isExpanded]);

  return (
    <ExpandableMenuContext.Provider value={{ isExpanded: expanded }}>
      <Container {...containerProps}>
        <Menu vertical className={className} {...testMetadata} {...otherProps}>
          {children}
        </Menu>
      </Container>
    </ExpandableMenuContext.Provider>
  );
};

export default ExpandableMenu;
